import { render, staticRenderFns } from "./ThreadsResult.vue?vue&type=template&id=0f321060"
import script from "./ThreadsResult.vue?vue&type=script&lang=ts"
export * from "./ThreadsResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports